<template>
  <Tooltip>
    <template #element>
      <span>
        Methode auswählen
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Wähle eine Methode mit großem Potential aus, um deine Wachstumsziele zu erreichen
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
